module.exports = __webpack_public_path__ + "static/media/ia_min.b76b3e37.png";